import tooltip from './tooltip/tooltip.js';

export const DIRECTIVES = [
  tooltip
];



// WEBPACK FOOTER //
// ./src/directives/index.js